<div id="{{id}}" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title text-center w-100" [innerHTML]="'MODAL.SECURITY_MODAL_TITLE' | translate"></h4>
        <button type="button" class="ttp-btn-close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <img src="assets/images/logos/dhs-seal.png" alt="{{'IMAGE_ALT.DHS_SEAL' | translate}}">
        </div>
        <p [innerHTML]=" 'MODAL.SECURITY_MODAL_BODY' | translate"></p>
      </div>
      <div class="modal-footer">
        <div class="row row-button-group w-100 justify-content-between flex-sm-row-reverse">
    	  	<div class="col-12 col-md-6">
          	<button type="button" class="btn d-block btn-primary w-100" (click)="continue()">
              <span translate>GENERAL_REUSABLE.CONSENT_CONTINUE</span>
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
        	</div>
          <div class="col-12 col-md-5">
            <button type="button" class="btn d-block ttp-btn-default w-100" (click)="decline()" data-bs-dismiss="modal">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
              <span translate>GENERAL_REUSABLE.DECLINE_EXIT</span>
            </button>
          </div>
        </div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

